module.exports = __webpack_public_path__ + "media/images/svg/clients/17-bd62ed340faaac416ade6877733e9a29.svg";